import {SearchModelBase} from './SearchModelBase';
import * as XCol from '../../framework.core/XExportColumn';
import _ from 'lodash';

export enum OimListType {
    Normal,
    NormalCan,
    UseLot
}

export class OiMblListItem extends SearchModelBase {
    closed: string = '';
    isClosed: boolean|null = null;
    shipmentType: string = '';
    invStat: string = '';
    billStat: string = '';
    crDbStat: string = '';
    refNo: string = '';
    hblCount: string = '';
    lotNo: string = '';
    branch: string = '';
    mblNo: string = '';
    agentId: number = 0;
    agentName: string = '';
    agentRefNo: string = '';
    vessel: string = '';
    voyage: string = '';
    acctCarrier: string = '';
    etd: string | null = null;
    fromEtd: string | null = null;
    toEtd: string | null = null;
    eta: string | null = null;
    fromEta: string | null = null;
    toEta: string | null = null;
    fEta: string | null = null;
    fromFEta: string | null = null;
    toFEta: string | null = null;
    moveType: string = '';
    eBl: boolean|null = null;
    expRls: boolean|null = null;
    oblDate: string | null = null;
    fromOblDate: string | null = null;
    toOblDate: string | null = null;
    rlsDate: string | null = null;
    fromRlsDate: string | null = null;
    toRlsDate: string | null = null;
    pnlDate: string | null = null;
    fromPnlDate: string | null = null;
    toPnlDate: string | null = null;
    finalDest: string = '';
    cyLocation: string = '';
    loadingPort: string = '';
    svccNo: string = '';
    containerNo: string = '';
    fullContainerNo: string = '';
    conType: string = '';
    operator: string = '';
    oFrt: string = '';
    paidDate: string | null = null;
    fromPaidDate: string | null = null;
    toPaidDate: string | null = null;
    oFrtCfrm: boolean|null = null;
    sMblNo: string = '';
    createdAt: string | null = null;
    fromCreatedAt: string | null = null;
    toCreatedAt: string | null = null;
    finalWhse: string = '';
    dvnEdi: string | null = null;
    fromDvnEdi: string | null = null;
    toDvnEdi: string | null = null;
    canShareFile: boolean = false;
    disCharge: string = '';
    postDate: string | null = null;
    pimsLinkId: number = 0;
    amsLinkId: number = 0;
    id: number = 0;
    cargoNo: string = '';
    custSName: string = '';
    sname: string = '';
    oFrtHold: boolean|null = null; // HOLD
    emptyRtnName: string = '';
    recognized: string = '';
    msManID: string = '';

    /**
     * A/D/PC (Period Closed)/OC (Operaion Closed)
     */
    status: string = '';

    // cloud
    /**
     * L = LCL, F = FCL, O = Consol
     */
    lclFcl: string = '';
    u2Date: string | null = null;
    fromU2Date: string | null = null;
    toU2Date: string | null = null;
    u2ID: string = '';
    u1ID: string = '';
    projectNo: string = '';
    canBeDeleted: boolean = false;

    trType: string = ''
    trStatus:string=''
    trStatusDesc:string=''
    trDate: string | null = null;
    fromTrDate: string | null = null;
    toTrDate: string | null = null;

    directBl: boolean = false;
    sbl: boolean = false;
    agentCnt: number = 0;  // total agent count

    //Track Event
    lastEvent: string = '';
    lastEventDate: string | null = null;

    chbRspCode: string = '';
    chbRspMsg: string = '';

    //memo
    memoCnt: string = '';   // total memo count
    taskPendingCnt: number = 0; // 로그인했을때 해당 유저로 Assign 된 Pending Task 개수

    confirmDate: string | null = null;
    fromConfirmDate: string | null = null;
    toConfirmDate: string | null = null;

    private static ExportCollection: XCol.XExportColumn[] = [
        XCol.Create({ col: 0, text: 'S', width: 30, dataIndex: 'status', hiddenInColumnSetup: true, visible: true }),
        XCol.Create({ col: 1, text: 'R.Date', width: 80, dataIndex: 'confirmDate', hiddenInColumnSetup: true, type: XCol.XCellType.Date, align: XCol.XAlignType.Center, visible: true }),
        XCol.Create({ col: 2, text: 'D/ID', width: 35, dataIndex: 'shipmentType', align: XCol.XAlignType.Center, noNullOrEmptySearch: true }),
        XCol.Create({ col: 3, text: 'INV', width: 35, dataIndex: 'invStat', align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 4, text: 'BIL', width: 35, dataIndex: 'billStat', align: XCol.XAlignType.Center, noNullOrEmptySearch: true}),
        XCol.Create({ col: 5, text: 'CrDb', width: 35, dataIndex: 'crDbStat', align: XCol.XAlignType.Center, noNullOrEmptySearch: true }),
        XCol.Create({ col: 6, text: 'Cargo', width: 80, dataIndex: 'lclFcl', visible: true, noNullOrEmptySearch: true}),
        XCol.Create({ col: 7, text: 'Ref. #', width: 100, dataIndex: 'refNo', defaultColumnFocus: true, visible: true }),
        XCol.Create({ col: 8, text: 'Task/Memo', width: 80, dataIndex: 'memoCnt', align: XCol.XAlignType.Center, visible: true }),
        XCol.Create({ col: 9, text: 'RQ Date', width: 100, dataIndex: 'trDate', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center, visible: true }),
        XCol.Create({ col: 10, text: 'Container Tracking', width: 210, dataIndex: 'trStatus' }),
        // XCol.Create({ col: 5, text: 'T', width: 50, dataIndex: 'trStatus2' }),
        //XCol.Create({ col: 6, text: 'R', width: 50, dataIndex: 're', visible: true }),

        // XCol.Create({ col: 7, text: 'Last Event', width: 85, dataIndex: 'lastEvent', noNullOrEmptySearch: true }),
        XCol.Create({ col: 11, text: 'BR', width: 40, dataIndex: 'branch', align: XCol.XAlignType.Center, visible: true }),
        XCol.Create({ col: 12, text: 'HBL(s)', width: 40, dataIndex: 'hblCount', visible: true, noNullOrEmptySearch: true }),
        XCol.Create({ col: 13, text: 'Lot ID', width: 80, dataIndex: 'lotNo', visible: true }),
        XCol.Create({ col: 14, text: 'MBL', width: 100, dataIndex: 'mblNo', visible: true }),
        XCol.Create({ col: 15, text: 'CBP', width: 40, dataIndex: 'chbRspCode', align: XCol.XAlignType.Center, noNullOrEmptySearch: true, visible: false }),
        XCol.Create({ col: 16, text: 'Project ID', width: 100, dataIndex: 'projectNo', visible: true }),
        XCol.Create({ col: 17, text: 'Agent', width: 120, dataIndex: 'agentName', visible: true }),
        XCol.Create({ col: 18, text: 'Agent Ref', width: 100, dataIndex: 'agentRefNo', visible: true }),
        XCol.Create({ col: 19, text: 'Vessel', width: 120, dataIndex: 'vessel', visible: true }),
        XCol.Create({ col: 20, text: 'Voyage', width: 60, dataIndex: 'voyage', visible: true }),
        XCol.Create({ col: 21, text: 'Freight Vendor', width: 120, dataIndex: 'acctCarrier', visible: true }),
        XCol.Create({ col: 22, text: 'ETD', width: 75, dataIndex: 'etd', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, visible: true }),
        XCol.Create({ col: 23, text: 'ETA', width: 75, dataIndex: 'eta', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, visible: true }),
        XCol.Create({ col: 24, text: 'F.ETA', width: 75, dataIndex: 'fEta', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, visible: true }),
        XCol.Create({ col: 25, text: 'Move Type', width: 80, dataIndex: 'moveType', visible: true, noNullOrEmptySearch: true }),
        XCol.Create({ col: 26, text: 'Container', width: 110, dataIndex: 'containerNo', visible: true }),
        XCol.Create({ col: 27, text: 'C. Type', width: 60, dataIndex: 'conType', visible: true }),
        XCol.Create({ col: 28, text: 'E-B/L', width: 50, dataIndex: 'eBl', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, visible: true, noNullOrEmptySearch: true }),
        XCol.Create({ col: 29, text: 'EXP RLS', width: 50, dataIndex: 'expRls', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, visible: true, noNullOrEmptySearch: true }),
        XCol.Create({ col: 30, text: 'MBL RCVD', width: 75, dataIndex: 'oblDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, visible: false }),
        XCol.Create({ col: 31, text: 'Carrier RLS', width: 75, dataIndex: 'rlsDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, visible: false }),
        XCol.Create({ col: 32, text: 'CrDb RCVD', width: 75, dataIndex: 'pnlDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, visible: false }),
        XCol.Create({ col: 33, text: 'Place of Delivery', width: 120, dataIndex: 'finalDest', visible: true }),
        XCol.Create({ col: 34, text: 'CY Location', width: 100, dataIndex: 'cyLocation', visible: true }),
        XCol.Create({ col: 35, text: 'Loading Port', width: 120, dataIndex: 'loadingPort', visible: true }),
        XCol.Create({ col: 36, text: 'Svc Contract', width: 90, dataIndex: 'svccNo', visible: false }),
        XCol.Create({ col: 37, text: 'Sales', width: 80, dataIndex: 'msManID', visible: true }),
        XCol.Create({ col: 38, text: 'Prep. By', width: 60, dataIndex: 'operator', visible: true }),
        XCol.Create({ col: 39, text: 'FRT CHRG', width: 60, dataIndex: 'oFrt', align: XCol.XAlignType.Center, visible: true }),
        XCol.Create({ col: 40, text: 'Paid', width: 75, dataIndex: 'paidDate', type: XCol.XCellType.Date, align: XCol.XAlignType.Center }),
        XCol.Create({ col: 41, text: 'FRT CFM', width: 60, dataIndex: 'oFrtCfrm', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, visible: true, noNullOrEmptySearch: true }),
        XCol.Create({ col: 42, text: 'HOLD', width: 40, dataIndex: 'oFrtHold', type: XCol.XCellType.Bool, align: XCol.XAlignType.Center, visible: true, noNullOrEmptySearch: true }),
        XCol.Create({ col: 43, text: 'Sub MBL', width: 80, dataIndex: 'sMblNo', visible: false }),
        XCol.Create({ col: 44, text: 'CFS Location', width: 100, dataIndex: 'finalWhse', visible: true }),
        XCol.Create({ col: 45, text: 'Devan EDI', width: 75, dataIndex: 'dvnEdi', type: XCol.XCellType.Date, align: XCol.XAlignType.Center, visible: false }),
        XCol.Create({ col: 46, text: 'Discharge Port', width: 120, dataIndex: 'disCharge', visible: true }),
        

        
        XCol.Create({ col: 47, text: 'Create Date', width: 100, dataIndex: 'createdAt', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center, visible: false }),
        XCol.Create({ col: 48, text: 'Create by', width: 80, dataIndex: 'u1ID', visible: false }),
        XCol.Create({ col: 49, text: 'Update Date', width: 100, dataIndex: 'u2Date', type: XCol.XCellType.DateTime, align: XCol.XAlignType.Center, visible: false }),
        XCol.Create({ col: 50, text: 'Update by', width: 80, dataIndex: 'u2ID', visible: false }),
    ];

    public static getExportCollection(ltype: OimListType, useBranch: boolean): XCol.XExportColumn[] {
        let expCollection = _.cloneDeep(this.ExportCollection);
        // // normal
        if (ltype === OimListType.Normal) {
            expCollection = expCollection.filter(x => x.dataIndex !== "lotNo");
            expCollection = expCollection.filter(x => x.dataIndex !== "cargoNo");
        }

        if (ltype === OimListType.UseLot) expCollection = expCollection.filter(x => x.dataIndex !== "cargoNo");
        if (!useBranch) expCollection = expCollection.filter(x => x.dataIndex !== 'branch');
        if (ltype === OimListType.NormalCan) expCollection = expCollection.filter(x => x.dataIndex !== 'chbRspCode');
        return expCollection;
    };
	
    public static OrderBy = { orderBy: OiMblListItem.prototype.id, orderByAscending: false };

    public static formatData(data: OiMblListItem[]) {
        return data.map((d: OiMblListItem) => ({
          ...d,
        }));
    }

    public static MapSearchFields: {[key: string]: {[key: string]: string}} = {
        etd: {from: 'fromEtd', to: 'toEtd' },
        eta: {from: 'fromEta', to: 'toEta' },
        fEta: {from: 'fromFEta', to: 'toFEta' },
        oblDate: {from: 'fromOblDate', to: 'toOblDate' },
        rlsDate: {from: 'fromRlsDate', to: 'toRlsDate' },
        pnlDate: {from: 'fromPnlDate', to: 'toPnlDate' },
        createdAt: {from: 'fromCreatedAt', to: 'toCreatedAt' },
        dvnEdi: {from: 'fromDvnEdi', to: 'toDvnEdi' },
        u2Date: {from: 'fromU2Date', to: 'toU2Date' },
        trDate: {from: 'fromTrDate', to: 'toTrDate' },
        paidDate: {from: 'fromPaidDate', to: 'toPaidDate' },
        confirmDate: {from: 'fromConfirmDate', to: 'toConfirmDate'}
    }

}
